/**
 * Small loading indicator shown next to messages that are being sent.
 * Displays a pulsing dot animation to indicate the message is in transit.
 */

import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ChatMessageSendingIndicatorProps {
  className?: string
}

const ChatMessageSendingIndicatorBase: React.FC<ChatMessageSendingIndicatorProps> = ({
  className,
}): ReactNode => (
  <output
    className={cn(
      'chat-message-sending-indicator flex items-center gap-0.5 text-muted-foreground',
      className
    )}
    aria-label="Sending message"
  >
    <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-current" />
    <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-current delay-75" />
    <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-current delay-150" />
  </output>
)

export const ChatMessageSendingIndicator = memo(ChatMessageSendingIndicatorBase)

ChatMessageSendingIndicator.displayName = 'ChatMessageSendingIndicator'
